import React, { Component } from 'react';
import Slider from "react-slick";

class Review extends Component {
    constructor(props){
        super(props);
        this.state = {
testimonial: [
    {
        id: 1,
        img: './assets/images/clients/test-1.jpg',
        alt: 'images',
        quoteText: 'Highly Recommended!',
        text: 'The Adaptive Control course introduced me to techniques that automatically adjust controller parameters in real time. This has been a game changer for dealing with uncertainties in industrial systems.',
        name: 'Alice Smith',
        desigantion: 'Automation Engineer'
    },
    {
        id: 2,
        img: './assets/images/clients/test-2.jpg',
        alt: 'images',
        quoteText: 'Excellent Course!',
        text: 'The System Identification course showed me how to model dynamic processes using convex optimization. The approach was rigorous but very practical for real-world applications.',
        name: 'Bob Johnson',
        desigantion: 'Process Engineer'
    },
    {
        id: 3,
        img: './assets/images/clients/test-3.jpg',
        alt: 'images',
        quoteText: 'Very Practical!',
        text: 'The Adaptive Control techniques I learned allow me to design controllers that remain stable and efficient even when system parameters change. It has improved my workflow significantly.',
        name: 'Carol White',
        desigantion: 'Control Specialist'
    },
    {
        id: 4,
        img: './assets/images/clients/test-4.jpg',
        alt: 'images',
        quoteText: 'Highly Informative!',
        text: 'The System Identification course combined theory and practice, showing how convex optimization frameworks can be applied to estimate reliable models from experimental data.',
        name: 'David Lee',
        desigantion: 'Instrumentation Engineer'
    },
]


        }
    }

    render() {
        const settings = {
            dots: true,
            infinite: true,
            centerMode: true,
            arrows: false,
            autoplay: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
          };
        return (
        <section className="testimonial section-padding dark-bg" id="testimonial">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-8">
                        <div className="section-heading center-heading text-center mb-60">
                            <h3 className="heading-title">Reviews from happy students</h3>
                            <p>These courses are essential for professionals who regularly work with clients.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <div className="testimonials-slides">
                            <Slider {...settings}>
                            {
                                this.state.testimonial.map((data)=> (
                                    <div className="review-item" key={data.id}>
                                        <div className="client-info">
                                            <div className="rating">
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                            </div>
                                            <h4>{data.quoteText}</h4>
                                            <p>{data.text}</p>
                                        </div>

                                        <div className="client-desc d-flex align-items-center">
                                            <div className="client-img">
                                                <img src={data.img} alt={data.alt} className="img-fluid"/>
                                            </div>
                                            <div className="client-text">
                                                <h5>{data.name}</h5>
                                                <span className="designation">{data.desigantion}</span>
                                            </div>
                                        </div>
                                    </div> 
                                ))
                            }
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    </section>
        );
    }
}

export default Review;
